// Brand constants: customer-facing brand is Destino Europe, endorsed by Espíritu Travel.
export const BRAND_NAME = "Destino Europe";
export const ENDORSEMENT = "by Espíritu Travel";
export const ENDORSER_NAME = "Espíritu Travel";
export const TAGLINE = "Your new life, together.";
export const TAGLINE_PARTS = { before: "Your ", emphasis: "new life", after: ", together." };
